import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getLanguage } from "../store/appSlice";
import { useMainStore } from "../store/mainStore";
import { allTranslations } from "./allTranslations";

declare module "i18next" {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

const initI18n = () => {
  const resources: Record<string, { translation: Record<string, string> }> = {
    en: { translation: {} },
    de: { translation: {} },
    tr: { translation: {} },
    cs: { translation: {} },
    ru: { translation: {} },
    hr: { translation: {} },
    es: { translation: {} },
    fr: { translation: {} },
    it: { translation: {} },
    sq: { translation: {} },
  };

  Object.entries(allTranslations).forEach(([key, translations]) => {
    resources.en.translation[key] = translations.en;
    resources.de.translation[key] = translations.de;
    resources.tr.translation[key] = translations.tr;
    // @ts-ignore
    resources.cs.translation[key] = translations.cs;
    // @ts-ignore
    resources.ru.translation[key] = translations.ru;
    // @ts-ignore
    resources.hr.translation[key] = translations.hr;
    // @ts-ignore
    resources.es.translation[key] = translations.es;
    // @ts-ignore
    resources.fr.translation[key] = translations.fr;
    // @ts-ignore
    resources.it.translation[key] = translations.it;
    // @ts-ignore
    resources.sq.translation[key] = translations.sq;
  });

  i18n.use(initReactI18next).init({
    compatibilityJSON: "v4",
    returnNull: false,
    resources,
    fallbackLng: "de",
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
  });
};

export const useI18nChangeLanguageHook = () => {
  const appLang = useMainStore(getLanguage);
  i18n.changeLanguage(appLang);
};

export default initI18n;
